module.exports = __webpack_public_path__ + "img/cbd-living-soap.45b6350c.jpg";